import { ErrorMessage, Field, Form, Formik } from 'formik'
import React, { useState } from 'react'
import * as Yup from 'yup'
import ModalError from '../Modals/ModalError'
import ModalSuccessful from '../Modals/ModalSuccessful'
import css from './Form.module.css'

const ContactForm = () => {
	const [modalSuccessIsOpen, setModalSuccessIsOpen] = useState(false)
	const [modalErrorIsOpen, setModalErrorIsOpen] = useState(false)

	const validationSchema = Yup.object().shape({
		name: Yup.string().required('Pole nie może być puste.'),
		email: Yup.string()
			.email('Proszę wprowadzić poprawny adres e-mail.')
			.required('Pole nie może być puste.'),
		messageTitle: Yup.string().required('Pole nie może być puste.'),
		phone: Yup.string()
			.required('Pole nie może być puste.')
			.matches(/^[0-9]{9,15}$/, 'Numer telefonu musi zawierać  9 do 15 cyfr.'),
		message: Yup.string().optional(),
		checkbox1: Yup.boolean().oneOf([true]),
		checkbox2: Yup.boolean().oneOf([true]),
	})

	const handleSubmit = async (values, { setSubmitting, resetForm }) => {
		try {
			const jsonData = {
				name: values.name,
				email: values.email,
				phone_number: values.phone,
				subject: values.messageTitle,
				message: values.message
			};

			const response = await fetch(process.env.REACT_APP_API_URL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify(jsonData)
			});

			if (response.ok) {
				setModalSuccessIsOpen(true);
				resetForm();
			} else {
				const errorResponse = await response.json();
				console.error("Помилка сервера:", errorResponse);
				setModalErrorIsOpen(true);
			}
		} catch (error) {
			console.error("Помилка мережі:", error);
			setModalErrorIsOpen(true);
		} finally {
			setSubmitting(false);
		}
	};



	return (
		<>
			<Formik
				initialValues={{
					name: '',
					email: '',
					messageTitle: '',
					phone: '',
					message: '',
					checkbox1: false,
					checkbox2: false,
				}}
				validationSchema={validationSchema}
				onSubmit={handleSubmit}
			>
				{({ isSubmitting, errors, touched }) => (
					<Form className={css.formContainer}>
						<h2 className={css.formTitle}>Napisz do nas</h2>
						<div className={css.firstSection}>
							<div className={css.labelContainer}>
								<label>
									<Field
										className={css.formInput}
										type='text'
										name='name'
										placeholder='Imię*'
										autoComplete='off'
										aria-required='true'
									/>
								</label>
								<ErrorMessage
									className={css.errorMsg}
									name='name'
									component='div'
								/>
							</div>

							<div className={css.labelContainer}>
								<label>
									<Field
										className={css.formInput}
										type='email'
										name='email'
										placeholder='Adres e-mail*'
										autoComplete='on'
										aria-required='true'
									/>
								</label>
								<ErrorMessage
									className={css.errorMsg}
									name='email'
									component='div'
								/>
							</div>

							<div className={css.labelContainer}>
								<label>
									<Field
										className={css.formInput}
										type='text'
										name='messageTitle'
										placeholder='Tytuł wiadomości*'
										aria-required='true'
									/>
								</label>
								<ErrorMessage
									className={css.errorMsg}
									name='messageTitle'
									component='div'
								/>
							</div>

							<div className={css.labelContainer}>
								<label>
									<Field
										className={css.formInput}
										type='text'
										name='phone'
										placeholder='Numer telefonu*'
										aria-required='true'
									/>
								</label>
								<ErrorMessage
									className={css.errorMsg}
									name='phone'
									component='div'
								/>
							</div>
						</div>

						<div className={css.secondSection}>
							<label className={css.labelTitle}>
								<Field
									className={css.formTextarea}
									as='textarea'
									name='message'
									aria-required='true'
									placeholder='Tu wpisz  treść ...'
								/>
							</label>
							<ErrorMessage
								className={css.errorMsg}
								name='message'
								component='div'
							/>
						</div>
						<label className={css.checkbox}>
							<Field
								className={css.customCheckboxInput}
								type='checkbox'
								name='checkbox1'
							/>
							<span className={css.customCheckbox}></span>
							<p
								className={`${css.text} ${
									errors.checkbox1 && touched.checkbox1 ? css.errorText : ''
								}`}
							>
								Wyrażam zgodę na kontakt telefoniczny (również MMS, SMS) w celu
								otrzymywania informacji  m.in. o oferowanych usługach, nowych
								możliwościach ofertowych i promocyjnych.
							</p>
						</label>

						<label className={css.checkbox}>
							<Field
								className={css.customCheckboxInput}
								type='checkbox'
								name='checkbox2'
							/>
							<span className={css.customCheckbox}></span>
							<p
								className={`${css.text} ${
									errors.checkbox2 && touched.checkbox2 ? css.errorText : ''
								}`}
							>
								Wyrażam zgodę na kontakt elektroniczny (email) w celu
								otrzymywania informacji o  m.in. o oferowanych usługach, nowych
								możliwościach ofertowych i promocyjnych.
							</p>
						</label>

						<button
							className={css.submitButtom}
							type='submit'
							disabled={isSubmitting}
						>
							Zarezerwuj teraz
						</button>
					</Form>
				)}
			</Formik>
			<ModalSuccessful
				isOpen={modalSuccessIsOpen}
				// isOpen={true}
				onRequestClose={() => setModalSuccessIsOpen(false)}
			/>
			<ModalError
				isOpen={modalErrorIsOpen}
				onRequestClose={() => setModalErrorIsOpen(false)}
			/>
		</>
	)
}

export default ContactForm
